











import { Vue, Component, Prop } from "vue-property-decorator";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

@Component({
  components: {
    PulseLoader
  }
})
export default class Loader extends Vue {
  @Prop({ type: Boolean }) readonly processing!: boolean;

  waitBeforeDisplay: boolean = true;

  get loading() {
    if (this.processing) {
      return this.waitBeforeDisplay || this.processing;
    }
    return this.waitBeforeDisplay;
  }

  mounted() {
    setTimeout(() => {
      this.waitBeforeDisplay = false;
    }, 800);
  }
}
